import React, { Component, ErrorInfo, ReactNode } from 'react';
import ErrorDisplay from './ErrorDisplay';
import { getUserFriendlyErrorMessage } from '../utils/errorMessage';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error,
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({
      hasError: false,
      error: null,
    });
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      const friendlyMessage = getUserFriendlyErrorMessage(
        this.state.error || new Error('Unknown error')
      );
      return (
        <ErrorDisplay
          error={friendlyMessage}
          onRetry={this.handleReset}
          title="Something went wrong"
          variant="full"
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

